import { type ReactNode } from "react";
import { NavLink } from "react-router";

import { signOut } from "../lib/api.js";

export interface ShellProps {
  children: ReactNode;
  email?: string;
  links: { label: string; to: string }[];
  title: string;
}

export function Shell({ children, email, links, title }: ShellProps) {
  return (
    <div className="min-h-screen bg-paper text-ink">
      <header className="border-b border-black/10 bg-white">
        <div className="mx-auto flex max-w-5xl flex-wrap items-center gap-4 px-6 py-4">
          <span className="text-lg font-semibold">{title}</span>
          <nav className="flex gap-4 text-sm">
            {links.map((link) => (
              <NavLink
                key={link.to}
                to={link.to}
                className={({ isActive }) =>
                  isActive
                    ? "font-semibold text-jay"
                    : "text-ink/70 hover:text-ink"
                }
              >
                {link.label}
              </NavLink>
            ))}
          </nav>
          <div className="ml-auto flex items-center gap-3 text-sm">
            {email ? <span className="text-ink/60">{email}</span> : null}
            <button
              type="button"
              onClick={signOut}
              className="rounded border border-black/15 px-3 py-1 hover:bg-black/5"
            >
              Sign out
            </button>
          </div>
        </div>
      </header>
      <main className="mx-auto max-w-5xl px-6 py-8">{children}</main>
    </div>
  );
}
